import React from 'react';
import ReactDOM from 'react-dom';
import CollapseNav from './components/nav-coll.jsx';

ReactDOM.render(
  <CollapseNav />,
  document.getElementById('nav')
);
